module.exports = __webpack_public_path__ + "media/sound_animal_made.b13c6763.mp3";